import { useState } from 'react';

interface FAQ {
  question: string;
  answer: string;
}

const faqs: FAQ[] = [
  {
    question: '草民影院需要付费吗？',
    answer: '草民影院完全免费，所有影视资源均可免费在线观看，无需注册会员，无需付费订阅。我们致力于为广大用户提供免费的高清影视观看体验。',
  },
  {
    question: '草民影院支持什么设备观看？',
    answer: '草民影院支持全平台观看，包括电脑、平板、手机等设备。无论您使用Windows、Mac、iOS还是Android系统，都可以流畅访问我们的网站。只需浏览器即可，无需下载任何APP。',
  },
  {
    question: '视频播放卡顿怎么办？',
    answer: '草民影院采用先进的CDN加速技术，提供多条线路自动切换。如果遇到卡顿，建议您：1）检查网络连接是否稳定；2）尝试切换视频清晰度；3）关闭其他占用带宽的应用程序。大部分情况下1080P高清画质都可以流畅播放。',
  },
  {
    question: '影片多久更新一次？',
    answer: '我们每天24小时不间断更新，热门电影和电视剧会在第一时间上线。院线新片也会在上映后以最快速度更新高清版本，让您不用等待太久就能在家观影。',
  },
  {
    question: '可以下载影片离线观看吗？',
    answer: '草民影院目前提供在线观看服务。出于版权和技术考虑，暂不支持影片下载功能。但您可以通过浏览器书签收藏喜欢的影片，随时回来在线观看。',
  },
  {
    question: '如何查找我想看的影片？',
    answer: '您可以通过多种方式查找影片：1）使用网站顶部的搜索框直接搜索片名；2）通过首页的影视分类浏览不同类型的内容；3）查看热门推荐和最新上线的精选列表。我们的搜索功能支持模糊匹配，输入片名关键字即可快速定位。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-white">
      <div className="max-w-screen-xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-serif">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于草民影院的常见疑问解答</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 flex items-center justify-between text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                  openIndex === index
                    ? 'bg-primary-500 text-white rotate-180'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}